import ApisService from './index'
import { ITransportationAdd, ITransportationUpdate, ITransportationImport } from '../interfaces/transportationInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'
import { CN } from '../constants/commonConstants'


export function createTransportation(data: ITransportationAdd) {

  const bodyData = {...data, ngayApDung: parseInt(data.ngayApDung), dacThuHangId: data.loai == CN ? null : data.dacThuHangId, donGiaKg: data.loai == CN ? null : data.donGiaKg}

  try {
    return ApisService.post('/hinhthucvanchuyen/create-hinhthucvanchuyen', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateTransportation(data: ITransportationUpdate) {
  const bodyData = {...data, ngayApDung: parseInt(data.ngayApDung), dacThuHangId: data.loai == CN ? null : data.dacThuHangId}
  try {
    return ApisService.put('/hinhthucvanchuyen/' + data.id + '/update-hinhthucvanchuyen', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateStatusTransportation(data: ITransportationUpdate) {
  try {
    return ApisService.put('/hinhthucvanchuyen/' + data.id + '/update-trangthai-htvc', {trangThai: data.trangThai})
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListTransportation(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/hinhthucvanchuyen/filter-hinhthucvanchuyen', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailTransportation(id: string) {
  try {
    return ApisService.get('/hinhthucvanchuyen/' + id + '/get-chitiet-hinhthucvanchuyen')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteTransportation(id: string) {
  try {
    return ApisService.delete('/hinhthucvanchuyen/' + id + '/delete-hinhthucvanchuyen')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function deleteMultiTransportation(idArr: Array<string>) {
  try {
    return ApisService.delete('/hinhthucvanchuyen/bulk-delete-hinhthucvanchuyen', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function importTransportation(data: Array<ITransportationImport>) {
  try {
    return ApisService.post('/hinhthucvanchuyen/import-hinhthucvanchuyen', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}


